export enum ChainId {
  HARDHAT = 31337,
  HARDHAT_ARBITRUM = 31338,
  HARDHAT_BASE = 31339,
  MAINNET = 1,
  SEPOLIA = 11155111,
  BASE_SEPOLIA = 84532,
  HORIZEN_TESTNET = 845320009,
  ARBITRUM_ONE = 42161,
  BASE = 8453,
}
